(function () {
  var wrap, textEl, barEl, threshold = 0;

  function bind() {
    wrap = document.querySelector('.free-ship-wrap');
    if (!wrap) return false;

    threshold = parseInt(wrap.getAttribute('data-threshold'), 10) || 0;
    textEl    = wrap.querySelector('.free-ship-text');
    barEl     = wrap.querySelector('.free-ship-bar');
    if (!(textEl && barEl)) return false;

    // Matcha primärknappens färg (t.ex. “Gå till kassan”)
    try {
      var btn = document.querySelector(
        '.cart-notification .button--primary, .cart-drawer .button--primary, .cart__ctas .button--primary, .button.button--primary'
      );
      if (btn) {
        var bg = getComputedStyle(btn).backgroundColor || '#15d3c7';
        barEl.style.setProperty('--accent', bg);
      }
    } catch(e){}

    return true;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('sv-SE', { style: 'currency', currency: 'SEK', minimumFractionDigits: 0 });
  }

  async function fetchCart() {
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return res.ok ? await res.json() : null;
    } catch { return null; }
  }

  function updateUI(total) {
    if (!bind()) return;

    var missing = Math.max(threshold - total, 0);
    var pct     = threshold > 0 ? Math.min(100, Math.max(1, Math.round((total / threshold) * 100))) : 1;

    // Driver gradienten i CSS
    barEl.style.setProperty('--fsb', pct + '%');

    if (missing > 0) {
      wrap.classList.remove('success');
      textEl.innerHTML = '<strong>' + formatMoney(missing) + '</strong> kvar till fri frakt';
    } else {
      wrap.classList.add('success');
      textEl.textContent = '🎉 Fri frakt!';
    }
  }

  async function refresh() {
    var cart = await fetchCart();
    if (cart && typeof cart.total_price === 'number') updateUI(cart.total_price);
  }

  // Notis/Drawer triggers
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(
      'button[name="add"], form[action^="/cart"] [type="submit"]'
    );
    if (btn) setTimeout(refresh, 250);
  });

  new MutationObserver(function(){ setTimeout(refresh, 100); })
    .observe(document.body, { childList: true, subtree: true });

  refresh();
})();
